import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";

interface LogoutProps {
  history: any;
}

const Logout = ({ history }: LogoutProps) => {
  useEffect(() => {
    localStorage.removeItem("authToken");
    history.push("/login");
  }, []);

  return <></>;
};

export default withRouter(Logout);
